var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMission = function SvgIconMission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_mission_svg__a)",
    fillRule: "evenodd",
    d: "M9.2 2.293a2.4 2.4 0 0 0-2.4 0L3.657 4.107a2.4 2.4 0 0 0-1.2 2.078v3.63a2.4 2.4 0 0 0 1.2 2.078L6.8 13.707a2.4 2.4 0 0 0 2.4 0l3.142-1.814a2.4 2.4 0 0 0 1.2-2.079V6.185a2.4 2.4 0 0 0-1.2-2.078zm0 2a2.4 2.4 0 0 0-2.4 0l-1.41.814a2.4 2.4 0 0 0-1.2 2.078v1.63a2.4 2.4 0 0 0 1.2 2.078l1.41.814a2.4 2.4 0 0 0 2.4 0l1.41-.814a2.4 2.4 0 0 0 1.2-2.079V7.185a2.4 2.4 0 0 0-1.2-2.078z",
    clipRule: "evenodd",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_mission_svg__b)",
    d: "M6.465 10.379 8 9.567l1.536.812c.13.068.283-.038.257-.178l-.319-1.678 1.272-1.178c.106-.098.047-.27-.098-.288l-1.737-.223-.752-1.537a.179.179 0 0 0-.317 0L7.09 6.834l-1.737.223c-.146.019-.204.19-.099.288l1.273 1.178-.32 1.678c-.026.14.129.246.258.178"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_mission_svg__c)",
    fillRule: "evenodd",
    d: "M6.8 1.893a2.4 2.4 0 0 1 2.4 0l3.49 2.014a2.4 2.4 0 0 1 1.2 2.079v4.029a2.4 2.4 0 0 1-1.2 2.078L9.2 14.107a2.4 2.4 0 0 1-2.4 0l-3.489-2.014a2.4 2.4 0 0 1-1.2-2.078v-4.03a2.4 2.4 0 0 1 1.2-2.078zm0 1.4a2.4 2.4 0 0 1 2.4 0l2.277 1.314a2.4 2.4 0 0 1 1.2 2.079v2.629a2.4 2.4 0 0 1-1.2 2.078L9.2 12.707a2.4 2.4 0 0 1-2.4 0l-2.276-1.314a2.4 2.4 0 0 1-1.2-2.078v-2.63a2.4 2.4 0 0 1 1.2-2.078z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_mission_svg__a",
    x1: 13.542,
    x2: 2.457,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFB98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_mission_svg__b",
    x1: 13.889,
    x2: 2.111,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFB98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_mission_svg__c",
    x1: 13.889,
    x2: 2.111,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFB98"
  })))));
};
export default SvgIconMission;